const PosKOTPrint = ({
  cart,
  reciptDetails,
  totalPrice,
  orderType,
  orderId,
  mobile,
  tenderedAmount,
  selectedDiscount,
  apiResponsePrint,
}) => {
  const getTableNumber = (item) => {
    const value = item?.table_no ?? item?.tableNo ?? "";

    return String(value).trim();
  };

  const handlePrintAPIKitchen = (reciptDetails, item, fullAddress) => {
    let formattedAddress = "Not available";

    try {
      const addressObj = JSON.parse(item.address_json);
      const values = addressObj?.values || {};

      formattedAddress = [
        values.name,
        values.house_number,
        values.address,
        values.landmark_area,
        values.city,
        values.state,
        values.in_pin_code,
        `Ph: ${values.phone_number}`,
      ]
        .filter(Boolean)
        .join(", ")
        .replace(/,/g, ",&nbsp;");
    } catch (error) {
      console.error("Failed to parse address_json:", error);
    }

    const deliveryInfo =
      item.orderType === "homedelivery"
        ? `
        <p class="textSizeMid">
            Delivery Partner Name: ${
              item.delivery_person_name
                ? item.delivery_person_name
                : "Not assigned"
            }
        </p>
        <p class="textSizeMid">
            Delivery Partner Mobile No.: ${
              item.delivery_person_number
                ? item.delivery_person_number
                : "Not assigned"
            }
        </p>`
        : ""; // If it's not home delivery, leave it as an empty string.

    const printWindow = window.open("", "_blank");
    // HTML content for the customer receipt
    const customerReceiptHTML = `
        <html>
            <head>
                <style>
                    @page {
                        size: 80mm;
                        margin: 0;
                    }
                    body {
                        margin: 0;
                        margin-right:15px;
                        font-family: Arial, sans-serif;
                        font-size: 16px;
                        color: black;
                    }
                    .header {
                        display: flex;
                        flex-direction: column;
                        justify-content: center; 
                        align-items: center;         
                        text-align: center;            
                        color: #000;
                        line-height: 1.1;
                        border-bottom: 1px dashed #000;
                        margin-top: 0px;
                    }
                    .header2 {
                        display: flex;
                        flex-direction: column;
                        justify-content: flex-start; 
                        align-items: flex-start;         
                        text-align: start;            
                        color: #000;
                       line-height: 1.5;
                        border-bottom: 1px dashed #000;
                        margin-top: 0px;
                        padding-bottom: 0px;
                    }
                    .headerTable {
                        width: 100%;
                        display: flex;
                        flex-direction: column;
                        justify-content: flex-start; 
                        align-items: flex-start;         
                        text-align: start;            
                        color: #000;
                        line-height: 1.2;
                        border-bottom: 1px dashed #000;
                        padding: 0;
                        margin: 0;
                    }
                    .headerTotal {
                        display: flex;
                        flex-direction: column;
                        justify-content: flex-start; 
                        align-items: flex-start;
                        text-align: left;            
                        color: #000;
                        line-height: 1.5;
                        border-bottom: 1px dashed #000;
                        padding-bottom: 5px;
                        padding-top: 5px;
                        padding:0px;
                    }
                        .flex-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
                    .headerEnd {
                        text-align: center;            
                        color: #000; 
                        padding-bottom: 0px;
                    }
                    .textSizeLarge {
                        font-size: 16px;
                        margin: 1px;
                        padding: 1px;
                    }
                    .textSizeMid {
                        font-size: 12px;
                        margin: 0px;
                        padding: 0px;
                    }
                    .textSizeSmall {
                        font-size: 9px;
                        margin: 1px;
                        padding: 1px;
                    }
                    .order-details { width: 100%; border-collapse: collapse; }
                    .order-details th,
                    .order-details td { padding: 0px;  padding-top: 5px;  padding-bottom: 5px; font-size: 12px; text-align: left;  vertical-align: top; }
                    .table-text-center { text-align: center; }
                </style>
            </head>
            <body>
                <div class="container">
                             <div class="header" style="text-align: left;">
  <p class="textSizeLarge" style="font-weight: 600; margin: 5px 0;">${
    reciptDetails.business_name
  } - KITCHEN COPY</p>
  <p class="textSizeMid" style="margin: 5px 0;">
    <strong>Order No:</strong> <strong>${item.daily_order_id}</strong>
  </p>
  <p class="textSizeMid" style="margin: 5px 0;">Date: ${item.order_date}</p>
  <p class="textSizeMid" style="margin: 5px 0;">Order Type: ${
    item.orderType
  }</p>
    ${
      getTableNumber(item)
        ? `
  <p class="textSizeMid">Table No: ${getTableNumber(item)}</p>
`
        : ""
    }
</div>
                    <div class="headerTable">
                        <table class="order-details" style=" border-collapse: collapse;">
                            <thead>
                                <tr>
                                    <th class="table-text-center" style=" padding-right:5px;">Sr.</th>
                                    <th class="table-text-center" sty>ITEM </th>
                                       <th class="table-text-center" sty>QTY </th>
                                    <th class="table-text-center" style="padding-left:5px; padding-right:5px;">PRC.</th>
                                    <th class="table-text-center">TTL.</th>
                                </tr>
                            </thead>
                           <tbody>
  ${item.items
    .map((subitem, index) => {
      let customizationText = "";

      try {
        const customization =
          subitem.customization && subitem.customization !== "{}"
            ? JSON.parse(subitem.customization)
            : null;

        if (customization) {
          const parts = Object.entries(customization).map(([key, value]) => {
            return `${Array.isArray(value) ? value.join(", ") : value}`;
          });
          customizationText = parts.length
            ? `<div class="custom-text">(${parts.join(" | ")})</div>`
            : "";
        }
      } catch {
        customizationText = `<div class="custom-text">(Invalid customization)</div>`;
      }

      return `
        <tr>
          <td class="table-text-center">${1 + index}</td>
          <td class="table-text-center">
            ${subitem.item_name}
            ${customizationText}
          </td> 
          
          <td class="table-text-center" style="padding-left:5px; ">
          ${subitem.quantity}
        
          </td>
         <td class="table-text-center" style="padding-left:5px; padding-right:5px;">${parseFloat(
           subitem.item_price,
         )}</td>
<td class="table-text-center">${parseFloat(subitem.total_price)}</td>
        </tr>
      `;
    })
    .join("")}
</tbody>
                        </table>
                    </div>
                
                




                     <div class="header2">
                        <p class="textSizeMid">Total Amount: Rs. ${
                          item.totalOrderPrice
                        }</p>
                    </div>
             
                </div>
            </body>
        </html>
    `;
    printWindow.document.write(customerReceiptHTML);
    printWindow.document.close(); // Close the document
    printWindow.focus(); // Focus on the new window
    printWindow.print(); // Trigger print for customer receipt
    printWindow.close(); // Close the print window after printing
  };

  const handleKitchenPrint = (reciptDetails, item, fullAddress) => {
    const formattedAddress = fullAddress.replace(/,/g, ",&nbsp;");
    const printWindow = window.open("", "_blank");

    // const orderKey = `printedOrders_${item.orderid}_${item.daily_order_id}`;
    const orderKey = `printedOrders_${item.orderid}`;

    // Retrieve printed items for this order from localStorage, or set an empty array if not found
    let printedItemsForOrder = JSON.parse(localStorage.getItem(orderKey)) || [];

    // Filter only items that haven't been printed yet for this specific order
    const unprintedItems = item.items.filter(
      (subitem) => !printedItemsForOrder.includes(subitem.id),
    );

    // If there are no unprinted items, exit the function
    if (unprintedItems.length === 0) {
      return;
    }

    // HTML content for the kitchen receipt
    const kitchenReceiptHTML = `
        <html>
            <head>
                <style>
                    @page {
                        size: 80mm;
                        margin: 0;
                    }
                    body {
                        margin: 0;
                         margin-right:15px;
                        font-family: Arial, sans-serif;
                        font-size: 12px;
                        color: black;
                    }
                    .header {
                        display: flex;
                        flex-direction: column;
                        justify-content: center; 
                        align-items: center;         
                        text-align: center;            
                        color: #000;
                        line-height: 1;
                        border-bottom: 1px dashed #000;
                        margin-top: 0px;
                    }
                    .header2 {
                        display: flex;
                        flex-direction: column;
                        justify-content: flex-start; 
                        align-items: flex-start;         
                        text-align: start;            
                        color: #000;
                        line-height: 1.5;
                        border-bottom: 1px dashed #000;
                        margin-top: 0px;
                        padding-bottom: 0px;
                    }
                    .headerTable {
                        width: 100%;
                        display: flex;
                        flex-direction: column;
                        justify-content: flex-start; 
                        align-items: flex-start;         
                        text-align: start;            
                        color: #000;
                        line-height: 1.1;
                        border-bottom: 1px dashed #000;
                        padding: 0;
                        margin: 0;
                    }
                    .order-details { width: 100%; border-collapse: collapse; }
                    .order-details th, .order-details td { padding: 5px; font-size: 14px; text-align: left; }
                    .table-text-center { text-align: center; }
                </style>
            </head>
            <body>
                <div class="container">
          <div class="header" style="text-align: left;">
  <p class="textSizeLarge" style="font-weight: 600; margin: 5px 0;">${
    reciptDetails.business_name
  } - KITCHEN COPY</p>
  <p class="textSizeMid" style="margin: 5px 0;">
    <strong>Order No:</strong> <strong>${item.daily_order_id}</strong>
  </p>
  <p class="textSizeMid" style="margin: 5px 0;">Date: ${item.order_date}</p>
  <p class="textSizeMid" style="margin: 5px 0;">Order Type: ${
    item.orderType
  }</p>
    ${
      getTableNumber(item)
        ? `
  <p class="textSizeMid">Table No: ${getTableNumber(item)}</p>
`
        : ""
    }
</div>
                    <div class="headerTable">
                        <table class="order-details" style="width: 100%; border-collapse: collapse;">
                            <thead>
                                <tr>
                                  <th class="table-text-center">Sr.</th>
                                    <th class="table-text-center">ITEM</th>
                                     <th class="table-text-center">QTY</th>
                                    <th class="table-text-center">PRICE</th>
                                </tr>
                            </thead>
        <tbody>
  ${item.items
    .map((subitem, index) => {
      let customizationText = "";
      try {
        // Check if customization is null or "{}" and set to empty string if so
        const customization =
          subitem.customization && subitem.customization !== "{}"
            ? JSON.parse(subitem.customization)
            : null;

        if (customization) {
          const parts = Object.entries(customization).map(([key, value]) => {
            return ` ${Array.isArray(value) ? value.join(", ") : value}`;
          });
          customizationText = parts.length
            ? `<div class="custom-text">(${parts.join(" | ")})</div>`
            : "";
        }
      } catch {
        customizationText = `<div class="custom-text">(Invalid customization)</div>`;
      }

      return `
        <tr>
          <td>${index + 1}</td>
          <th>${subitem.product_id}${customizationText}</th>
       <th>${subitem.quantity}</th>
          <td>${parseFloat(subitem.item_price)}</td>
        </tr>
      `;
    })
    .join("")}
</tbody>
                        </table>
                    </div>
                    <div class="header2">
                        <p class="textSizeMid">Total Amount: Rs. ${
                          item.totalOrderPrice
                        }</p>
                    </div>
                </div>
            </body>
        </html>
    `;
    // Open a new window for the kitchen receipt
    printWindow.document.write(kitchenReceiptHTML);
    printWindow.document.close(); // Close the document
    printWindow.focus(); // Focus on the new window
    printWindow.print(); // Trigger print for kitchen receipt
    printWindow.close(); // Close the print window after printing
    const updatedPrintedItems = [
      ...printedItemsForOrder,
      ...unprintedItems.map((subitem) => subitem.id),
    ];
    // Save the updated printed items list in localStorage under the dynamic order key
    localStorage.setItem(orderKey, JSON.stringify(updatedPrintedItems));
  };
  return (
    <>
      <button
        id="pos-kitchen-print-btn"
        onClick={() => {
          if (Array.isArray(apiResponsePrint)) {
            if (apiResponsePrint.length > 0) {
              handlePrintAPIKitchen(reciptDetails, apiResponsePrint[0], "");
            }
          } else if (apiResponsePrint && typeof apiResponsePrint === "object") {
            handlePrintAPIKitchen(reciptDetails, apiResponsePrint, "");
          } else {
            console.error("Kitchen print data invalid");
          }
        }}
        className="shadow-md border border-gray-300 m-2 rounded-lg bg-gray-100 
             flex justify-center items-center text-lg font-bold 
             hover:bg-gray-200 cursor-pointer"
        style={{ height: "120px", width: "250px" }}
      >
        KITCHEN PRINT
      </button>
    </>
  );
};

export default PosKOTPrint;
